<template>
  <div class="card-button" v-on="disabled ? {} : { click: action }" v-bind:class="[cardStyle, { 'disabled': disabled }]" >
    <div class="button-title">{{ title }}</div>
    <div class="button-subtitle">{{ subtitle }}</div>
    <loader v-if="loading" class="button-loader"></loader>
  </div>
</template>

<script>

import Loader from '../Loader.vue';

export default {
  name: 'CardButton',
  components: {
    Loader,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    title: String,
    subtitle: String,
    cardStyle: String,
    action: Function,
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';

  .card-button {
    --shadow-blue: #2666b2;
    --shadow-red: #fe3140;
  }

  .primary {
    color: white;
    background: $riseup_blue;

    &:active {
      box-shadow: inset 0 0 10px 1px var(--shadow-blue);
    }

    &.disabled {
      opacity: 0.4;
    }
  }

  .secondary {
    border: 2px solid $riseup_blue;
    color: $riseup_blue;
    background: white;

    &:active {
      box-shadow: inset 0 0 8px 1px var(--shadow-blue);
    }
  }

  .warning {
    border: 2px solid $riseup_red;
    color: $riseup_red;
    background: white;

    &:active {
      box-shadow: inset 0 0 8px 2px var(--shadow-red);
    }
  }

  .card-button {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 95px;
    border-radius: 3px;
    cursor: pointer;
    &.disabled {
      cursor: default;
    }

    .button-title {
      font-family: SimplerProBold;
      font-size: 20px;
    }

    .button-subtitle {
      font-size: 16px;
      font-weight: normal;
    }
  }
</style>
<style lang="scss">
  // this css isn't scoped because it needs to override the internal css of the loader
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  .card-button .button-loader {
    position: absolute;
    bottom: 0;
    .bar:nth-child(1) {
      background-color: $riseup_blue !important;
    }
  }
</style>
